import React from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useIntl } from 'react-intl';
import HomePageContainer
  from '@fuww/library/src/Articles/Homepage/Container';
import Head from '../Head';
import ArticleLayout from '../News/ArticleLayout';
import { useSiteContext } from '../SiteContext';
import InView from '../InView';
import messages from '../../lib/messages.json';
import getSearchJsonLdData from '../../lib/getSearchJsonLdData';
import loading from '../../lib/loading';
import DynamicWfbAdsSection from '../News/ArticleLayout/DynamicWfbAdsSection';

const DynamicCategoryNewsSection = dynamic(() => import(
  '../News/Homepage/CategoryNews'
), {
  ssr: false,
  loading,
});

const Index = () => {
  const intl = useIntl();
  const router = useRouter();
  const { newsboard, jobsComplete } = useSiteContext();

  return (
    <HomePageContainer>
      <Head
        title={intl.formatMessage(messages.indexTitle)}
        description={intl.formatMessage(messages.indexDescription)}
        jsonLdData={getSearchJsonLdData(router, intl)}
      />
      <ArticleLayout
        categorySection={(
          <InView>
            <DynamicCategoryNewsSection />
          </InView>
        )}
        wfbAds={jobsComplete && (<DynamicWfbAdsSection />)}
        showCreatedAt
        expandedSections
        featuredVariables={[
          'FASHIONUNITED_INFO',
        ].includes(newsboard)
          ? {
            featured: null,
          }
          : null}
      />
    </HomePageContainer>
  );
};

export default Index;
